export default __webpack_public_path__ + "static/media/front_strawberry_003.8d292dfc.png";